import * as types from '../../constants/monitoring/statisticsConstants';
import {
  STATISTICS_GEM_EXCEL_DATA_REQUEST, STATISTICS_ITEM_ITEMS_EXCEL_DATA_REQUEST,
  STATISTICS_NFT_BOX_EXCEL_DATA_REQUEST, STATISTICS_NFT_LEVEL_EXCEL_DATA_REQUEST, STATISTICS_NFT_STAT_EXCEL_DATA_REQUEST
} from '../../constants/monitoring/statisticsConstants';

// 요약
export const statisticsSummaryListRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_SUMMARY_LIST_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

// 재무

// 토큰
export const statisticsTokenListRequest = ({
  beginDate,
  endDate,
  transactionType,
  callback,
  error,
}) => ({
  type: types.STATISTICS_TOKEN_LIST_REQUEST,
  beginDate,
  endDate,
  transactionType,
  callback,
  error,
});

export const statisticsTokenExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_TOKEN_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
})

// 마켓
export const statisticsCarListRequest = ({
  beginDate,
  endDate,
  nftType,
  nftGrade,
  nftSeal,
  isPlus,
  callback,
  error,
}) => ({
  type: types.STATISTICS_CAR_LIST_REQUEST,
  beginDate,
  endDate,
  nftType,
  nftGrade,
  nftSeal,
  isPlus,
  callback,
  error,
});

export const statisticsCarExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_CAR_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

export const statisticsCarBoxListRequest = ({
  beginDate,
  endDate,
  boxType,
  boxGrade,
  isPlus,
  callback,
  error,
}) => ({
  type: types.STATISTICS_CAR_BOX_LIST_REQUEST,
  beginDate,
  endDate,
  boxType,
  boxGrade,
  isPlus,
  callback,
  error,
});

export const statisticsCarBoxExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_CAR_BOX_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

export const statisticsItemsListRequest = ({
  beginDate,
  endDate,
  itemType,
  itemLevel,
  callback,
  error,
}) => ({
  type: types.STATISTICS_ITEMS_LIST_REQUEST,
  beginDate,
  endDate,
  itemType,
  itemLevel,
  callback,
  error,
});

export const statisticsItemsExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_ITEMS_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

export const statisticsGemListRequest = ({
  beginDate,
  endDate,
  gemType,
  gemLevel,
  callback,
  error,
}) => ({
  type: types.STATISTICS_GEM_LIST_REQUEST,
  beginDate,
  endDate,
  gemType,
  gemLevel,
  callback,
  error,
});

export const statisticsGemExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_GEM_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

// NFT
export const statisticsNFTCarListRequest = ({
  nftType,
  nftGrade,
  nftSeal,
  isPlus,
  callback,
  error,
}) => ({
  type: types.STATISTICS_NFT_CAR_LIST_REQUEST,
  nftType,
  nftGrade,
  nftSeal,
  isPlus,
  callback,
  error,
});

export const statisticsNFTCarExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_NFT_CAR_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

export const statisticsNFTLevelStatListRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_NFT_LEVEL_STAT_LIST_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

export const statisticsNFTLevelExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_NFT_LEVEL_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

export const statisticsNFTStatExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_NFT_STAT_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

export const statisticsNFTBoxListRequest = ({
  beginDate,
  endDate,
  boxType,
  boxGrade,
  callback,
  error,
}) => ({
  type: types.STATISTICS_NFT_BOX_LIST_REQUEST,
  beginDate,
  endDate,
  boxType,
  boxGrade,
  callback,
  error,
});

export const statisticsNFTBoxExcelDataRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_NFT_BOX_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});

// 아이템
export const statisticsItemItemsListRequest = ({
  beginDate,
  endDate,
  itemType,
  gemType,
  level,
  isGem,
  callback,
  error,
}) => ({
  type: types.STATISTICS_ITEM_ITEMS_LIST_REQUEST,
  beginDate,
  endDate,
  itemType,
  gemType,
  level,
  isGem,
  callback,
  error,
});

export const statisticsItemItemsExcelDataRequest = ({
  beginDate,
  endDate,
  isGem,
  callback,
  error,
}) => ({
  type: types.STATISTICS_ITEM_ITEMS_EXCEL_DATA_REQUEST,
  beginDate,
  endDate,
  isGem,
  callback,
  error,
});


// 유저
export const statisticsUserListRequest = ({
  beginDate,
  endDate,
  callback,
  error,
}) => ({
  type: types.STATISTICS_USER_LIST_REQUEST,
  beginDate,
  endDate,
  callback,
  error,
});
